import { render, staticRenderFns } from "./RemitOneLiveRates.vue?vue&type=template&id=0879a34c"
import script from "./RemitOneLiveRates.vue?vue&type=script&lang=js"
export * from "./RemitOneLiveRates.vue?vue&type=script&lang=js"
import style0 from "./RemitOneLiveRates.vue?vue&type=style&index=0&id=0879a34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports